module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[108]473.4116970.woff2";